/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import axios from 'axios'
import mainApi from './modules/main'
import msgApi from './modules/main/message'
import userApi from './modules/user'
import settingApi from './modules/user/security'
import commonApi from './modules/main/common'
import authApi from './modules/user/auth'
import organizationApi from './modules/user/organization'

export default {
    axios: axios,
    mainApi: mainApi,
    userApi,
    settingApi,
    commonApi,
    authApi,
    organizationApi,
    msgApi
}



// WEBPACK FOOTER //
// ./src/api/index.js